import styled from "styled-components";

const Wrapper = styled.main`
  background: linear-gradient(135deg, #0a0e27 0%, #1a1a1a 50%, #0a0e27 100%);
  position: relative;

  /* Add subtle animated background pattern */
  &::before {
    content: "";
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: radial-gradient(
        circle at 20% 50%,
        rgba(28, 91, 152, 0.05) 0%,
        transparent 50%
      ),
      radial-gradient(
        circle at 80% 80%,
        rgba(80, 191, 255, 0.05) 0%,
        transparent 50%
      );
    pointer-events: none;
    z-index: 0;
  }

  .footer-info {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .business-name {
    font-size: 0.9rem;
    margin-bottom: 0.25rem;
    color: #a0a0a0;
  }

  .navbar-container {
    display: flex;
    justify-content: center;
    position: fixed;
    min-width: 100vw;
    background: rgba(10, 14, 39, 0.8);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    border-bottom: 1px solid rgba(80, 191, 255, 0.1);
    height: 5rem;
    z-index: 1000;
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  }
  .navbar {
    font-family: "Inter", sans-serif;
    top: 0;
    width: 100%;
    max-width: 1120px;
    background: transparent;
    padding: 0.75rem 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 5rem;
    transition: all 0.3s ease-in-out;
  }
  .navbar.open {
    background: transparent;
  }
  .navbar-button {
    background: transparent;
    border: 2px solid var(--brand-light-blue);
    color: var(--brand-light-blue);
    border-radius: 8px;
    margin-right: 1rem;
    padding: 0.5rem 0.75rem;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    overflow: hidden;
  }

  .navbar-button::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 0;
    height: 0;
    border-radius: 50%;
    background: var(--brand-light-blue);
    transition: width 0.6s, height 0.6s, top 0.6s, left 0.6s;
    transform: translate(-50%, -50%);
    z-index: -1;
  }

  .navbar-button:hover::before {
    width: 300px;
    height: 300px;
  }

  .navbar-button:hover {
    color: #1a1a1a;
    cursor: pointer;
    transform: translateY(-2px);
    box-shadow: 0 10px 20px rgba(80, 191, 255, 0.3);
  }

  .navbar-button-alt {
    background: linear-gradient(
      135deg,
      var(--brand-light-blue) 0%,
      #1c5b98 100%
    );
    border: 2px solid transparent;
    color: #ffffff;
    border-radius: 8px;
    margin-right: 1rem;
    padding: 0.5rem 0.75rem;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 2px 8px rgba(80, 191, 255, 0.15);
  }

  .navbar-button-alt:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(80, 191, 255, 0.25);
  }

  .navbar-button-orange {
    background: linear-gradient(135deg, #fe7648 0%, #e25e35 100%);
    box-shadow: 0 2px 8px rgba(254, 118, 72, 0.15);
  }

  .navbar-button-orange:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(254, 118, 72, 0.35);
  }

  .logo {
    width: 10rem;
    height: auto;
    margin-top: 0.5rem;
    transition: transform 0.3s ease-in-out;
  }
  .logo.open {
    justify-self: center;
  }
  .menu-icon {
    display: none;
    cursor: pointer;
    height: 1.75rem;
    transition: transform 0.3s ease-in-out;
  }

  .icon-style {
    width: 2rem;
    height: 2rem;
    color: white;
  }
  .icon {
    transition: transform 0.3s ease-in-out;
  }

  .icon.hamburger {
    transform: rotate(0deg);
  }

  .icon.close {
    transform: rotate(90deg);
    margin: -0.25rem 0.25rem 0 0;
  }

  .nav-links {
    display: flex;
    align-items: center;
  }

  .nav-link {
    color: black;
    text-decoration: none;
  }
  .landing-login {
    padding: 0.375rem 0.75rem;

    width: 4.5rem;
    height: 2rem;
  }

  @media (max-width: 768px) {
    .navbar-container {
      height: 5rem;
    }

    .navbar {
      height: 5rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0.75rem 1rem;
    }

    .menu-icon {
      display: block;
      z-index: 1001;
    }

    .nav-links {
      display: flex;
      flex-direction: column;
      gap: 0;
      position: absolute;
      top: 5rem;
      left: 0;
      width: 100%;
      background: rgba(10, 14, 39, 0.95);
      backdrop-filter: blur(15px);
      -webkit-backdrop-filter: blur(15px);
      border-bottom: 1px solid rgba(80, 191, 255, 0.2);
      overflow: hidden;
      max-height: 0;
      opacity: 0;
      transition: max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1),
        opacity 0.3s ease-in-out;
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
    }

    .nav-links.open {
      max-height: 400px;
      opacity: 1;
    }

    .navbar-button,
    .navbar-button-alt,
    .navbar-button-orange {
      display: block;
      width: calc(100% - 2rem);
      text-align: center;
      margin: 0.75rem 1rem;
      padding: 0.875rem 1rem;
      border-radius: 12px;
      font-weight: 500;
      transition: all 0.3s ease;

      &:first-child {
        margin-top: 1rem;
      }

      &:last-child {
        margin-bottom: 1rem;
      }
    }

    .navbar-button {
      background: rgba(28, 91, 152, 0.2);
      border: 2px solid rgba(80, 191, 255, 0.4);
      color: var(--brand-light-blue);

      &:active {
        background: rgba(28, 91, 152, 0.4);
        transform: scale(0.98);
      }
    }

    .navbar-button-alt {
      background: linear-gradient(
        135deg,
        var(--brand-light-blue) 0%,
        #1c5b98 100%
      );
      border: 2px solid transparent;
      color: #ffffff;
      font-weight: 600;
      box-shadow: 0 4px 12px rgba(80, 191, 255, 0.25);

      &:active {
        transform: scale(0.98);
      }
    }

    .navbar-button-orange {
      background: linear-gradient(135deg, #fe7648 0%, #e25e35 100%);
      border: 2px solid transparent;
      color: #ffffff;
      font-weight: 600;
      box-shadow: 0 4px 12px rgba(254, 118, 72, 0.25);

      &:active {
        transform: scale(0.98);
      }
    }

    /* Remove hover effects on mobile */
    .navbar-button::before,
    .navbar-button-alt::before {
      display: none;
    }
  }
  .landing-container {
    padding-top: 5rem;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    color: #ffffff;
    @media (max-width: 768px) {
      padding-top: 7rem;
    }
  }

  .landing-text-header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin-top: 6rem;
    width: 100%;
    color: #ffffff;
    padding: 0 0.5rem;
    position: relative;
    z-index: 1;

    h1 {
      color: #ffffff;
      font-size: 2.25rem;
      font-weight: 700;
      text-transform: none;
      line-height: 1.2;
      text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
    }
    h3 {
      color: #ffffff;
      font-size: 2.25rem;
      font-weight: 700;
      text-transform: none;
      line-height: 1.2;
      text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
    }
    p {
      color: #ffffff;
      font-family: "Inter", sans-serif;
    }
    @media (min-width: 768px) {
      padding: 2rem;

      h1 {
        font-size: 3rem;
      }
      p {
        font-size: 1.5rem;
      }
    }
  }
  .header-span {
    background: linear-gradient(
      135deg,
      var(--brand-light-blue) 0%,
      #50bfff 100%
    );
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
  .landing-description {
    margin: 0.25rem;
    font-weight: 500;
    font-size: 1rem;
    font-family: "Inter", sans-serif;
    @media (min-width: 768px) {
      font-size: 1.25rem;
    }
  }

  .landing-group {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;

    @media (min-width: 992px) {
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
      padding: 0 12rem;
    }
  }
  .landing-group-text {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    p {
      line-height: 2rem;
    }
    @media (min-width: 992px) {
      text-align: left;
      max-width: 25rem;
      // margin-left: 4rem;
    }
  }

  .landing-group-images {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: fit-content;
    @media (min-width: 992px) {
      //margin: 0 -2rem;
    }
  }
  .landing-image {
    margin-top: 2rem;
    max-width: 100%;
    border-radius: 15px;
    z-index: 10;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4), 0 0 40px rgba(80, 191, 255, 0.1);
    transition: transform 0.3s ease;

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 25px 70px rgba(0, 0, 0, 0.5),
        0 0 50px rgba(80, 191, 255, 0.2);
    }

    @media (min-width: 992px) {
      max-width: 60%;
    }
  }

  .landing-image2 {
    margin-top: 1rem;
    width: 75%;
    border-radius: 15px;
    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.3), 0 0 30px rgba(80, 191, 255, 0.1);
    transition: transform 0.3s ease;

    &:hover {
      transform: translateY(-5px) scale(1.02);
    }

    @media (min-width: 768px) {
      margin-top: -1rem;
      width: 60%;
    }
    @media (min-width: 992px) {
      margin-top: -1rem;
      width: 40%;
    }
  }

  .landing-image2-1 {
    margin-top: 2rem;
    width: 95%;
    border-radius: 15px;
    z-index: 10;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4), 0 0 40px rgba(80, 191, 255, 0.1);
    transition: transform 0.3s ease;

    &:hover {
      transform: translateY(-5px);
    }

    @media (min-width: 992px) {
      width: 75%;
    }
  }
  .feature-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 10rem;
    color: #ffffff;
    text-align: center;
    max-width: 100%;
  }
  .feature-buttons {
    max-width: 100%;
    display: flex;
    white-space: nowrap;
    overflow-x: auto;
    overflow-y: visible;
    -webkit-overflow-scrolling: touch;
    margin-bottom: 1rem;
    padding: 0.5rem 0;
    border-radius: 20px;
  }
  .feature-button {
    background: rgba(28, 91, 152, 0.3);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    white-space: nowrap;
    font-family: "Inter", sans-serif;
    border: 2px solid rgba(80, 191, 255, 0.2);
    border-radius: 12px;
    color: #ffffff;
    cursor: pointer;
    font-size: 1rem;
    padding: 0.5rem 1.5rem;
    margin: 0.5rem;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    flex-shrink: 0;
    position: relative;
    overflow: hidden;

    @media (min-width: 768px) {
      font-size: 1.25rem;
    }

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        90deg,
        transparent,
        rgba(80, 191, 255, 0.3),
        transparent
      );
      transition: left 0.5s;
      border-radius: 12px;
    }

    &:hover::before {
      left: 100%;
    }
  }

  .feature-button.active,
  .feature-button:hover {
    background: rgba(28, 91, 152, 0.6);
    border-color: rgba(80, 191, 255, 0.6);
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(80, 191, 255, 0.4);
  }
  .feature-details {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    justify-content: center;

    align-items: center;
    text-align: center;
    margin-top: 0.5rem;
    max-width: 1000px;
    height: auto;
    opacity: 1;
    transition: opacity 0.25s ease-in-out;
    @media (min-width: 768px) {
    }
    @media (min-width: 992px) {
      flex-direction: row;
      justify-content: space-between;

      flex-wrap: nowrap;
      height: 300px;
    }
  }
  .feature-details.fade-out {
    opacity: 0;
  }

  .feature-details.fade-in {
    opacity: 1;
  }

  .feature-image {
    width: 100%;
    max-width: 300px;
    height: 300px;
    object-fit: cover;
    margin: 10px;
    border-radius: 20px;
    box-shadow: 0 15px 50px rgba(0, 0, 0, 0.4),
      0 0 30px rgba(80, 191, 255, 0.15);
    transition: all 0.3s ease;

    &:hover {
      transform: scale(1.03) translateY(-5px);
      box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5),
        0 0 40px rgba(80, 191, 255, 0.25);
    }

    @media (max-width: 768px) {
      width: 100%;
      max-width: 350px;
      height: 300px;
      border-radius: 20px;
    }
  }

  .feature-text {
    font-family: "Inter", sans-serif;
    padding: 1rem;
    display: flex;
    flex-wrap: wrap;
    font-size: 1.125rem;

    color: #ffffff;
    width: auto;
    max-width: 400px;
    word-wrap: break-word;

    @media (min-width: 768px) {
      font-size: 1.25rem;
      max-width: fit-content;
    }
  }

  .feature-title {
    color: #333;
  }

  .feature-description {
    color: #666;
  }

  //PRICING
  .pricing-container {
    margin-top: 10rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .toggle-buttons {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 2rem;
  }

  .toggle-buttons .switch {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 34px;
    margin-right: 1rem;
  }

  .toggle-buttons .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .toggle-buttons .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: 0.4s;
    border-radius: 34px;
  }

  .toggle-buttons .slider:before {
    position: absolute;
    content: "";
    height: 26px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    transition: 0.4s;
    border-radius: 50%;
  }

  .toggle-buttons input:checked + .slider {
    background-color: #007bff;
  }

  .toggle-buttons input:checked + .slider:before {
    transform: translateX(26px);
  }
  .pricing-table {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    align-items: center;
  }
  .pricing-group {
    display: flex;
    flex-direction: row;

    @media (max-width: 768px) {
      display: flex;
      flex-direction: column;
      width: 100%;
    }
  }

  .pricing-plan {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background: rgba(28, 91, 152, 0.3);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    padding: 2rem;
    border-radius: 24px;
    margin: 1rem 1rem;
    width: 100%;
    max-width: 400px;
    min-width: 360px;
    text-align: center;
    border: 2px solid rgba(80, 191, 255, 0.2);
    box-shadow: 0 15px 50px rgba(0, 0, 0, 0.3), 0 0 30px rgba(80, 191, 255, 0.1);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
      transform: translateY(-10px);
      border-color: rgba(80, 191, 255, 0.5);
      box-shadow: 0 25px 70px rgba(0, 0, 0, 0.4),
        0 0 50px rgba(80, 191, 255, 0.25);
    }

    @media (max-width: 768px) {
      margin: 1rem 0;
    }
  }

  .pricing-plan h4 {
    font-family: "Inter", sans-serif;
    margin-bottom: 0.5rem;
    font-weight: 700;
    font-size: 1rem;
  }

  .pricing-plan p.price {
    font-size: 2rem;
    margin-bottom: 1rem;
    color: var(--brand-light-blue);
    font-weight: 700;
    margin-top: 0.5rem;
    line-height: 2rem;
  }

  .pricing-plan p.billed-yearly {
    font-size: 1rem;
    margin: 0;
    color: white;
  }

  .pricing-plan ul {
    list-style-type: none;
    padding: 0;
    margin-bottom: 1rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-self: center;
    align-self: auto;
  }

  .pricing-plan ul li {
    font-family: "Inter", sans-serif;
    margin-bottom: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
  }

  .pricing-plan button {
    background: linear-gradient(
      135deg,
      var(--brand-light-blue) 0%,
      #1c5b98 100%
    );
    font-weight: 600;
    color: #fff;
    padding: 0.75rem 2rem;
    border: none;
    border-radius: 12px;
    cursor: pointer;
    width: 10rem;
    align-self: center;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 2px 8px rgba(80, 191, 255, 0.2);

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 15px rgba(80, 191, 255, 0.3);
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
      transform: none;
    }
  }
  .price-text {
    color: #ffffff;
  }
  .checkmark {
    width: 1.5rem;
    height: 1.5rem;
    margin-right: 0.5rem;
  }

  //CONTACT FORM
  .contact-form {
    width: 25rem;

    @media (max-width: 768px) {
      width: 100%;
    }
  }
  .form-group {
    margin: 1.75rem 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
  }

  .form-group label {
    display: block;
    margin-bottom: 0.25rem;
  }

  .form-group input,
  .form-group select,
  .form-group textarea {
    width: 100%;
    padding: 0.75rem;
    border-radius: 12px;
    border: 2px solid rgba(80, 191, 255, 0.3);
    background: rgba(255, 255, 255, 0.05);
    backdrop-filter: blur(10px);
    color: #ffffff;
    transition: all 0.3s ease;
    font-family: inherit;

    &:focus {
      outline: none;
      border-color: var(--brand-light-blue);
      box-shadow: 0 0 20px rgba(80, 191, 255, 0.3);
      background: rgba(255, 255, 255, 0.1);
    }

    &::placeholder {
      color: rgba(255, 255, 255, 0.5);
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }

  .form-group input,
  .form-group select {
    height: 3.5rem;
  }

  .form-group textarea {
    min-height: 120px;
    resize: vertical;
  }

  .error-message {
    color: #ff6b6b;
    font-size: 0.875rem;
    margin-top: 0.25rem;
  }

  .error-message-box {
    background: rgba(255, 107, 107, 0.1);
    border: 2px solid rgba(255, 107, 107, 0.3);
    border-radius: 12px;
    padding: 1rem;
    margin-bottom: 1.5rem;
    color: #ff6b6b;
    text-align: center;
  }

  .success-message {
    background: rgba(80, 191, 255, 0.1);
    border: 2px solid rgba(80, 191, 255, 0.3);
    border-radius: 12px;
    padding: 2rem;
    margin-top: 2rem;
    text-align: center;

    h4 {
      color: var(--brand-light-blue);
      margin-bottom: 1rem;
      font-size: 1.5rem;
    }

    p {
      color: #ffffff;
      font-size: 1.125rem;
    }
  }

  .phone-input-container {
    display: flex;
    flex-direction: column;

    width: 100%;
    border-radius: 8px;
    overflow: hidden;
  }

  .phone-input-container select {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
  .phone-input-container input {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  button[type="submit"] {
    padding: 0.75rem 2rem;
    background: linear-gradient(135deg, #50bfff 0%, #1c5b98 100%);
    border: none;
    border-radius: 12px;
    color: #ffffff;
    cursor: pointer;
    font-size: 1rem;
    font-weight: 700;
    margin-top: 0.5rem;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 3px 10px rgba(80, 191, 255, 0.25);

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 5px 18px rgba(80, 191, 255, 0.35);
    }

    &:active {
      transform: translateY(-1px);
    }
  }

  .expert-reach-out {
    margin-top: 1.5rem;
  }
  //Footer
  .footer {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    border-top: 1px solid rgb(145, 145, 145);
    color: #fff;
    font-family: "Inter", sans-serif;
    @media (min-width: 768px) {
      padding: 1rem 2rem;
    }
    @media (min-width: 992px) {
      padding: 1rem 5rem;
    }
  }
  .footer-top {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    width: 100%;
    @media (min-width: 768px) {
      padding: 0rem 2rem;
    }
    @media (min-width: 992px) {
      padding: 1rem 0rem;
      flex-direction: row;
      justify-content: space-between;
    }
  }
  .footer-group {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    @media (min-width: 768px) {
      flex-direction: row;
    }
    @media (min-width: 992px) {
      justify-content: flex-start;
      align-items: flex-start;
    }
  }
  .footer-section {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    padding: 1rem;
  }

  .footer-list {
    list-style-type: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    span {
      color: #919191;
      font-weight: 900;
    }
    li {
      font-weight: 300;
    }
    @media (min-width: 992px) {
      padding: 1rem 0rem;
      justify-content: flex-start;
      align-items: flex-start;
    }
  }

  .footer-link {
    color: #fff;
    text-decoration: none;
    margin-bottom: 10px;
  }

  .footer-link:hover {
    text-decoration: underline;
  }

  .footer-button {
    padding: 12px 24px;
    border: 2px solid var(--brand-light-blue);
    color: #fff;
    text-decoration: none;
    text-align: center;
    border-radius: 12px;
    max-width: 14rem;
    font-weight: 700;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    overflow: hidden;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 0;
      height: 100%;
      background: linear-gradient(
        135deg,
        var(--brand-light-blue) 0%,
        #50bfff 100%
      );
      transition: width 0.4s ease;
      z-index: -1;
    }

    &:hover::before {
      width: 100%;
    }
  }

  .footer-button:hover {
    color: #1a1a1a;
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(80, 191, 255, 0.4);
  }

  .footer-bottom {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    width: 100%;
    padding: 1rem;
    height: 10rem;

    @media (min-width: 768px) {
      padding: 0;
      height: 8rem;
    }
    @media (min-width: 992px) {
      flex-direction: row;
      justify-content: space-between;
      padding: 1.5rem;
      padding-bottom: 0.5rem;
    }
  }

  .footer-logo {
    font-size: 20px;
    font-weight: bold;
  }

  .footer-copyright {
    font-size: 14px;
  }

  //OLD COMPONENT
  nav {
    width: var(--fluid-width);
    max-width: var(--max-width);
    margin: 0 auto;
    height: var(--nav-height);
    display: flex;
    align-items: center;
  }
  .page {
    min-height: calc(100vh - var(--nav-height));
    display: grid;
    align-items: center;
  }
  h1 {
    font-weight: 700;
    span {
      color: var(--primary-500);
    }
  }
  p {
    color: var(--grey-600);
  }
  .main-img {
    display: none;
  }
  @media (min-width: 992px) {
    .page {
      grid-template-columns: 1fr 1fr;
      column-gap: 3rem;
    }
    .main-img {
      display: block;
      width: 20rem;
    }
  }
  .fade-in-section {
    opacity: 0;
    transition: opacity 1s ease-in-out;
    width: 100%;
  }

  .fade-in-section.is-visible {
    opacity: 1;
  }

  .feature-enter {
    opacity: 0;
    transform: scale(0.9);
  }
  .feature-enter-active {
    opacity: 1;
    transform: scale(1);
    transition: opacity 300ms, transform 300ms;
  }
  .feature-exit {
    opacity: 1;
    transform: scale(1);
  }
  .feature-exit-active {
    opacity: 0;
    transform: scale(0.9);
    transition: opacity 300ms, transform 300ms;
  }
`;
export default Wrapper;
